export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';
export const SCROLL_CONTENT = 'SCROLL_CONTENT';
export const CONTENT_SCROLLED = 'CONTENT_SCROLLED';
export const SET_LAST_USED_DEPOSIT_DETAILS = 'SET_LAST_USED_DEPOSIT_DETAILS';

export const showAlert = (title, description, callback = null) => {
  return {
    type: SHOW_ALERT,
    payload: {
      alertTitle: title,
      alertDescription: description,
      showAlert: true,
      alertCallbackRef: callback,
    },
  };
};

export const setLastUsedDepositDetails = details => {
  return {
    type: SET_LAST_USED_DEPOSIT_DETAILS,
    payload: {
      lastUsedDepositDetails: details,
    },
  };
};

export const hideAlert = () => {
  return {
    type: HIDE_ALERT,
    payload: {
      alertTitle: '',
      alertDescription: '',
      showAlert: false,
      alertCallbackRef: null,
    },
  };
};

export const scrollContentToTop = () => {
  return {
    type: SCROLL_CONTENT,
    payload: {
      requestScroll: true,
      targetScrollPosition: 0,
    },
  };
};

export const contentScrolledToTop = () => {
  return {
    type: CONTENT_SCROLLED,
    payload: {
      requestScroll: false,
      targetScrollPosition: 0,
    },
  };
};



// WEBPACK FOOTER //
// ./src/actions/client/index.js